import * as React from "react";

export interface KeyValueRow {
  label: string;
  value: React.ReactNode;
}

interface KeyValueCardContentProps {
  rows: KeyValueRow[];
  badge?: React.ReactNode;
  className?: string;
}

/**
 * Card content layout matching webhook cards: first row has label+value on the left
 * and optional badge on the right (no empty row). Subsequent rows are label+value only.
 */
export function KeyValueCardContent({ rows, badge, className }: KeyValueCardContentProps) {
  if (rows.length === 0) return null;

  const [first, ...rest] = rows;
  const labelClass = "text-sm font-medium text-muted-foreground";

  return (
    <div className={className ?? "space-y-3"}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <label className={labelClass}>{first.label}</label>
          <div className="mt-1 min-w-0">{first.value}</div>
        </div>
        {badge != null ? <span className="shrink-0">{badge}</span> : null}
      </div>
      {rest.map((row, index) => (
        <div key={index} className="min-w-0">
          <label className={labelClass}>{row.label}</label>
          <div className="mt-1 min-w-0">{row.value}</div>
        </div>
      ))}
    </div>
  );
}
